<template>
    <div>
      <Pos_sale_report_round/>
    </div>
  </template>
  
  <script>
  import Pos_sale_report_round from "@/components/adminArin/pos_system/pos/Pos_sale_report_round";
  export default {
    name: "PosSaleReportRound",
    components: {
      Pos_sale_report_round
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  